import fetch from '../../../core/fetch';
import history from '../../../core/history';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const dynamicBlogDetails = values?.dynamicBlogDetails?.filter(
    item => item && item.language
  ) || [];

  const firstItem = dynamicBlogDetails?.[0];

  const mutation = `
    mutation updateBlogDetails(
      $id: Int,
      $metaTitle: String,
      $metaDescription: String,
      $pageUrl: String,
      $pageTitle: String,
      $content: String,
      $footerCategory: String,
      $dynamicBlogDetails: String
    ) {
      updateBlogDetails(
        id: $id,
        metaTitle: $metaTitle,
        metaDescription: $metaDescription,
        pageUrl: $pageUrl,
        pageTitle: $pageTitle,
        content: $content,
        footerCategory: $footerCategory,
        dynamicBlogDetails: $dynamicBlogDetails
      ) {
        status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: mutation,
      variables: {
        id: values.id,
        metaTitle: firstItem.metaTitle,
        metaDescription: firstItem?.metaDescription,
        pageUrl: values.pageUrl,
        footerCategory: values.footerCategory,
        pageTitle: firstItem?.pageTitle || '',
        content: firstItem?.content || '',
        dynamicBlogDetails: JSON.stringify(dynamicBlogDetails),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateBlogDetails.status === "success") {
    showToaster({ messageId: 'updateBlogSuccess', toasterType: 'success' });
    history.push('/siteadmin/content-management');
  } else if (data.updateBlogDetails.status === 'URL exist') {
    showToaster({ messageId: 'addBlogFailed', toasterType: 'error' });
  } else {
    showToaster({ messageId: 'failedToUpdateBlog', toasterType: 'error' });
  }
}

export default submit;